module.exports = __webpack_public_path__ + "img/radar-mira.992b0bc8.webp";